import { render, staticRenderFns } from "./shopCheckPayment.vue?vue&type=template&id=0bf296be&scoped=true"
import script from "./shopCheckPayment.vue?vue&type=script&lang=js"
export * from "./shopCheckPayment.vue?vue&type=script&lang=js"
import style0 from "./shopCheckPayment.vue?vue&type=style&index=0&id=0bf296be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf296be",
  null
  
)

export default component.exports